<template>
  <div class="login" id="login">
    <div class="header flex flex-cross-center">
      <img src="../assets/img/login_logo.png" alt />
    </div>
    <div
      class="login-body login-mode flex flex-main-justify"
      v-show="mode == 'login'"
    >
      <div></div>
      <div class="login-btn-box">
        <p class="title">Sign In</p>
        <div class="body flex flex-dir-top">
          <el-input v-model="user" placeholder="Email"></el-input>
          <el-input
            v-model="psd"
            placeholder="Password"
            @keyup.enter.native="login"
            type="password"
          ></el-input>
          <el-checkbox class="remember-psd" v-model="rememberPSD"
            >Remember password</el-checkbox
          >
          <el-button type="primary" @click="login">Login</el-button>
          <div class="func flex">
            <span class="cp" @click="changeMode('register')">Sign up</span>
            <span class="sign">|</span>
            <span class="cp" @click="changeMode('forgetPsd')"
              >Forget password ?</span
            >
          </div>
        </div>
      </div>
    </div>
    <div
      class="login-body register flex flex-main-justify"
      v-if="mode == 'register'"
    >
      <div>
        <p class="info">
          Join us on a green journey towards a more connected carbon-free
          society
        </p>
        <div class="line"></div>
      </div>
      <div class="login-btn-box">
        <p class="title pr">
          <i class="el-icon-back tvc cp" @click="changeMode('login')"></i
          >Register
        </p>
        <div class="body flex flex-dir-top">
          <el-form
            :model="registerForm"
            status-icon
            :rules="registerRules"
            ref="ruleForm"
            class="demo-ruleForm"
          >
            <el-form-item label prop="name">
              <el-input
                v-model="registerForm.name"
                placeholder="Your name"
              ></el-input>
            </el-form-item>
            <el-form-item label prop="email">
              <el-input
                type="email"
                v-model="registerForm.email"
                placeholder="Your email"
              ></el-input>
            </el-form-item>
            <el-form-item label prop="phone">
              <el-input
                v-model.number="registerForm.phone"
                placeholder="Your phone"
              ></el-input>
            </el-form-item>
            <el-checkbox v-model="treatyChecked"
              >Read and accept the agreement</el-checkbox
            >
            <el-form-item>
              <el-button type="primary" @click="sendEmail('ruleForm')"
                >Send Email</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <div
      class="login-body forget-psd flex flex-main-justify"
      v-if="mode == 'forgetPsd'"
    >
      <div>
        <p class="info">Glad you have used our products,</p>
        <p class="info">
          If you
          <span>"forgot your password"</span>
        </p>
        <p class="info">
          You can contact us by email, we will contact you as soon as possible.
        </p>
        <div class="line"></div>
      </div>
      <div class="login-btn-box">
        <p class="title">Forget password</p>
        <div class="body flex flex-dir-top">
          <p class="tip">Please enter your email</p>
          <div class="flex no-border-input">
            <el-input
              v-model="email"
              placeholder="email"
              type="email"
            ></el-input>
          </div>
          <el-button type="primary" @click="getCode">Next</el-button>
          <div class="func flex cp" @click="changeMode('login')">
            <i class="el-icon-back"></i>
            <span>Login</span>
          </div>
        </div>
      </div>
    </div>
    <div
      class="login-body reset-psd flex flex-main-justify"
      v-show="mode == 'resetPsd'"
    >
      <div>
        <p class="info">Glad you have used our products,</p>
        <p class="info">You can set your new password through this page.</p>
        <div class="line"></div>
      </div>
      <div class="login-btn-box">
        <p class="title">Forget password</p>
        <div class="body flex flex-dir-top no-border-input">
          <p class="tip">Email verification code</p>
          <el-input v-model="code" placeholder="code"></el-input>
          <p class="tip">New password</p>
          <el-input
            v-model="newPsd"
            placeholder="new password"
            type="password"
          ></el-input>
          <p class="tip">Confirm new password</p>
          <el-input
            v-model="confirmNewPsd"
            placeholder="confirm new password"
            type="password"
          ></el-input>
          <el-button type="primary" @click="resetPsd">Reset Password</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      registerForm: {
        name: "",
        email: "",
        phone: ""
      },
      registerRules: {
        name: [
          { required: true, message: "Please input name", trigger: "blur" },
          {
            min: 2,
            max: 16,
            message: "2 to 16 characters in length",
            trigger: "blur"
          }
        ],
        email: [
          { required: true, message: "Please input email", trigger: "blur" },
          {
            type: "email",
            required: true,
            message: "please enter your vaild email",
            trigger: "blur"
          }
        ],
        phone: [
          { required: true, message: "Please input phone", trigger: "blur" }
        ]
      },
      registerName: "",
      registerEmail: "",
      registerPhone: "",
      treatyChecked: false,
      user: "",
      psd: "",
      slideUp: false,
      mode: "login",
      rememberPSD: false,
      radioList: [
        {
          text: "Forget password",
          mode: "forgetPsd"
        },
        {
          text: "Register",
          mode: "register"
        }
      ],
      email: "",
      newPsd: "",
      confirmNewPsd: "",
      code: ""
    };
  },
  created() {
    if (localStorage.getItem("userName")) {
      this.user = localStorage.getItem("userName");
      this.psd = localStorage.getItem("password");
      this.rememberPSD = true;
    }
  },
  methods: {
    sendEmail(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$http
            .get(
              "/apis/admin/register/userinfo/send/" +
                this.registerForm.name +
                "/" +
                this.registerForm.email +
                "/" +
                this.registerForm.phone,
              {},
              {
                noCheck: true
              }
            )
            .then((res) => {
              console.log(res, "rres");
              this.$message({
                type: "success",
                message:
                  "Send success! Please wait for the administrator to process."
              });
              setTimeout(() => {
                this.mode = "login";
              }, 2000);
            });
        } else {
          return false;
        }
      });
    },
    login() {
      if (!this.user) {
        this.emptyTip("Username or email");
      } else if (!this.psd) {
        this.emptyTip("Password");
      } else {
        let param =
          "username=" +
          this.user +
          "&password=" +
          this.Encrypt(this.psd) +
          "&scope=server&grant_type=password";
        this.$http
          .post("/apis/auth/oauth/token", param, {
            "content-type": "application/x-www-form-urlencoded",
            Authorization: "Basic dGVzdDp0ZXN0"
          })
          .then((res) => {
            if (res && res.access_token) {
              if (res.user_info.roles[0] == 3) {
                this.$message({
                  showClose: true,
                  message: "该账号没有权限",
                  type: "error"
                });
              } else {
                this.$store.commit("updateToken", res.access_token);
                this.$store.commit("updateRefreshToken", {
                  refreshToken: res.refresh_token,
                  updateTime: new Date().getTime() + res.expires_in * 1000
                });
                res.user_info.type = "10";
                this.$store.commit("updateUserInfo", res.user_info);
                this.$store.commit(
                  "updateUserAuthority",
                  res.user_info.authorities
                );
                this.$store.commit("updateUserRoles", res.user_info.roles[0]);
                sessionStorage.setItem("userName", this.user);
                if (this.rememberPSD) {
                  localStorage.setItem("userName", this.user);
                  localStorage.setItem("password", this.psd);
                } else {
                  localStorage.setItem("userName", "");
                  localStorage.setItem("password", "");
                }
                if (res.user_info.roles[0] == 1) {
                  this.PUSH({
                    name: "main-commodity-list"
                  });
                }
                if (res.user_info.roles[0] == 2) {
                  this.PUSH({
                    name: "main-shop-goods-list"
                  });
                }
              }
            } else {
              this.$message({
                showClose: true,
                message: "Wrong email or password",
                type: "error"
              });
            }
          })
          .catch((err) => {
            console.log(err, "err");
            err.msg &&
              this.$message({
                showClose: true,
                message: err.msg,
                type: "error"
              });
          });
      }
    },
    changeMode(val) {
      this.mode = val;
    },
    forgetPsd() {},
    emptyTip(str) {
      this.$message({
        showClose: true,
        message: str + " cannot be empty",
        type: "error"
      });
    },
    resetPsd() {
      if (!this.code) {
        this.emptyTip("code");
      } else if (!this.newPsd) {
        this.emptyTip("New password");
      } else if (!this.confirmNewPsd) {
        this.emptyTip("Confirm new password");
      } else if (this.newPsd != this.confirmNewPsd) {
        this.$message({
          showClose: true,
          message: "The new password is inconsistent with the confirm password",
          type: "error"
        });
      } else {
        let param = {
          email: this.email,
          password: this.newPsd,
          ranCode: this.code
        };
        this.$http
          .get("/apis/admin/register/update", param, {
            noCheck: true
          })
          .then((res) => {
            console.log(res, "reset");
            if (res.code == 0) {
              this.$message({
                showClose: true,
                message: "Password modified successfully",
                type: "success"
              });
              this.mode = "login";
            }
          });
      }
    },
    getCode() {
      if (this.email) {
        if (this.judgeEmail(this.email)) {
          this.$http
            .get(
              "/apis/admin/register/check/" + this.email,
              {},
              { noCheck: true }
            )
            .then((res) => {
              if (res && res.code == 0) {
                this.$message({
                  showClose: true,
                  message: "The verification code is sent successfully",
                  type: "success"
                });
                this.mode = "resetPsd";
              } else {
                this.$message({
                  showClose: true,
                  message: "User does not exist",
                  type: "error"
                });
              }
            });
        } else {
          this.$message({
            showClose: true,
            message: "Email error",
            type: "error"
          });
        }
      } else {
        this.emptyTip("Email");
      }
    }
  }
};
</script>

<style lang='scss'>
$borderColor: #c9d1d8;
#login {
  width: 100%;
  height: 100%;
  background-size: 100% 100%;
  position: relative;
  background-image: url("../assets/img/login_bg.png");
  margin: 0;
  top: 0;
  left: 0;
  .header {
    height: 60px;
    padding-right: 0.49rem;
    padding-left: 0.5rem;
    img {
      width: 204px;
      height: 32px;
    }
  }
  .forget-psd-register {
    width: 62px;
    height: 66px;
    position: absolute;
    right: 86px;
    top: 51px;
    input {
      margin-bottom: 0.4rem;
    }
  }
  .login-body {
    padding: 1.15rem 1.65rem 0 0.98rem;
    float: right;
    width: 100%;
    button {
      border: none;
    }
    input {
      color: #fff;
    }
    &.forget-psd {
      .el-input {
        margin-bottom: 0.4rem;
      }
      p {
        font-size: 0.24rem;
        color: #fff;
        span {
          font-size: 0.32rem;
        }
      }
      .tip {
        margin: 0.2rem 0;
      }
    }
    &.reset-psd {
      padding-top: 0.76rem;
      .tip {
        margin-top: 0.2rem;
        margin-bottom: 0.1rem;
      }
      input {
        color: #fff;
      }
      button {
        margin-top: 0.4rem;
      }
    }
    &.register {
      p {
        &.tip {
          font-size: 0.24rem;
          margin-bottom: 0.64rem;
        }
        &.text {
          font-size: 0.32rem;
          margin-bottom: 3rem;
        }
      }
      .login-btn-box {
        .el-input {
          margin-top: 0.4rem;
        }
      }
      .el-icon-back {
        color: rgb(0, 128, 208);
        font-size: 0.4rem;
        left: 0.2rem;
      }
      .el-checkbox {
        position: absolute;
      }
      .el-form-item {
        margin-bottom: 30px;
      }
      button {
        height: 0.72rem;
        width: 100%;
        display: inline-block;
        text-align: center;
        font-size: 0.24rem;
        color: #fff;
        background-color: rgb(0, 93, 192);
        border-radius: 4px;
        cursor: pointer;
        margin-top: 0.6rem;
      }
    }
    &.login-mode {
      .el-input {
        margin-top: 0.64rem;
      }
    }
    .info {
      font-size: 0.24rem;
      color: #fff;
      margin-bottom: 0.36rem;
      margin-top: 0.36rem;
    }
    .line {
      width: 2.46rem;
      height: 1px;
      background-color: $borderColor;
    }
    .login-btn-box {
      width: 6.44rem;
      height: 6.6rem;
      background-color: rgba(0, 0, 0, 0.6);
      .title {
        font-size: 0.36rem;
        color: #28b5e1;
        height: 1.22rem;
        line-height: 1.22rem;
        text-align: center;
      }
      .tip {
        font-size: 0.14rem;
        color: #999;
      }
      .no-border-input {
        input {
          border: none;
          color: #fff;
          font-size: 0.2rem;
          padding-left: 0;
        }
        .el-input {
          border-bottom: 1px solid $borderColor;
        }
      }
      .body {
        padding: 0.73rem;
        padding-top: 0;
      }
      .el-input {
        &:first-child {
          margin-top: 0;
        }
      }
      .remember-psd {
        margin: 0.4rem 0;
        color: #999;
      }
      .el-input {
        border-bottom: 1px solid #28b5e1;
      }
      input {
        margin-right: 20px;
        width: 100%;
        height: 0.72rem;
        font-size: 0.24rem;
        border: none;
        background: none;
      }
      button {
        border: 1px solid #28b5e1;
        background: none;
        color: #fff;
        font-size: 0.24rem;
        height: 0.78rem;
        &::placeholder {
          color: rgba(255, 255, 255, 0.4);
        }
      }
      .func {
        margin-top: 0.2rem;
        .el-icon-back {
          font-size: 0.16rem;
          color: #297fca;
          margin-right: 0.12rem;
          font-weight: bold;
        }
        span {
          font-size: 0.12rem;
          color: #666;
          &.sign {
            margin: 0 0.1rem;
          }
        }
      }
    }
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.1s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  .slide-up-enter-active,
  .slide-up-leave-active {
    transition: all 0.6s;
  }
  .slide-up-enter-to {
    bottom: 0;
  }
  .slide-up-enter, .slide-up-leave-to /* .fade-leave-active below version 2.1.8 */ {
    bottom: -1000px !important;
  }
}
</style>
